/**
 * Query builders for enrollment reads, parameterised by the Supabase client.
 *
 * These live outside enrollmentService.js only so they can be exercised
 * directly with a fake client — enrollmentService.js reaches the shared client
 * through Vite-resolved extensionless imports that node cannot load.
 */

const ENROLLMENT_WITH_COURSE_SELECT = `
          *,
          course:courses (
            id, 
            title, 
            short_description, 
            duration_hours, 
            certification_provided, 
            thumbnail_url, 
            iso_standard, 
            difficulty_level,
            category:course_categories(name)
          )
        `;

const BATCH_ENROLLMENT_SELECT = `
            status,
            batch:training_batches!inner(course_id, partner_id, delivery_mode)
          `;

export function createEnrollmentQueries(client) {
  return {
    /** My Courses / dashboard listing, scoped to a partner store when given. */
    userEnrollments({ userId, platform, partnerId = null }) {
      let query = client
        .from("course_enrollments")
        .select(ENROLLMENT_WITH_COURSE_SELECT)
        .eq("user_id", userId)
        .eq("platform", platform);

      if (partnerId) {
        query = query.eq("partner_id", partnerId);
      }

      return query
        .neq("enrollment_status", "cancelled")
        .order("enrolled_at", { ascending: false });
    },

    /**
     * Self-paced ownership. Batch checkout also writes a course_enrollments
     * row for material access, so the row's own delivery_mode is what
     * distinguishes the two — never the payment or grant it came from.
     */
    selfPacedEnrollments(userId) {
      return client
        .from("course_enrollments")
        .select("*")
        .eq("user_id", userId)
        .eq("delivery_mode", "self_paced")
        .in("enrollment_status", ["active", "completed"]);
    },

    /** Confirmed cohort seats, used for the virtual/classroom variants. */
    batchEnrollments(userId) {
      return client
        .from("batch_enrollments")
        .select(BATCH_ENROLLMENT_SELECT)
        .eq("user_id", userId)
        .in("status", ["confirmed", "completed"]);
    },
  };
}
